import React from 'react';
import { bool, func, node, shape, string } from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const MDialog = props => {
  const {
    centeredHeader,
    header,
    open,
    onClose,
    contentText,
    children,
    leftButtonAction,
    leftButtonDisabled,
    leftButtonText,
    rightButtonAction,
    rightButtonDisabled,
    rightButtonText,
    slotProps: externalSlotProps,
    loading,
    ...dialogProps
  } = props;

  const slotProps = {
    ...externalSlotProps,
    paper: {
      elevation: 4,
      ...(externalSlotProps?.paper || {}),
    },
  };

  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      maxWidth="xs"
      onClose={onClose}
      open={open}
      scroll="paper"
      {...dialogProps}
      slotProps={slotProps}
    >
      {header && (
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            pt: 3,
            textAlign: centeredHeader ? 'center' : '',
          }}
        >
          {header}
        </DialogTitle>
      )}
      <DialogContent
        sx={{
          flex: '0 0 auto',
          overflowY: 'visible',
          pb: 2,
          px: 3,
        }}
      >
        {contentText && <DialogContentText>{contentText}</DialogContentText>}
        {children}
      </DialogContent>
      {!rightButtonText && !leftButtonText ? null : (
        <DialogActions
          sx={{
            gridColumnGap: 8,
            pb: 3,
            px: 3,
          }}
        >
          {leftButtonText && (
            <Button disabled={leftButtonDisabled} onClick={leftButtonAction} variant="outlined">
              {leftButtonText}
            </Button>
          )}
          {rightButtonText && (
            <Button disabled={rightButtonDisabled} onClick={rightButtonAction}>
              {rightButtonText}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

MDialog.propTypes = {
  centeredHeader: bool,
  children: node,
  contentText: string,
  header: string,
  leftButtonAction: func,
  leftButtonDisabled: bool,
  leftButtonText: string,
  loading: bool,
  onClose: func,
  open: bool.isRequired,
  rightButtonAction: func,
  rightButtonDisabled: bool,
  rightButtonText: string,
  slotProps: shape({
    paper: shape({}),
    transition: shape({}),
  }),
};

MDialog.defaultProps = {
  centeredHeader: false,
  children: null,
  contentText: '',
  header: '',
  leftButtonAction: null,
  leftButtonDisabled: false,
  leftButtonText: '',
  loading: false,
  onClose: undefined,
  rightButtonAction: null,
  rightButtonDisabled: false,
  rightButtonText: '',
  slotProps: undefined,
};

export default MDialog;
